var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.msg),expression:"msg"}],class:[_vm.color],attrs:{"width":"100%"}},[_c('rect',{attrs:{"x":_vm.marginLeft,"y":_vm.marginTop,"width":_vm.width,"height":_vm.height + 'px',"fill-opacity":"0.8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }